import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { Filter } from '~/api/seller-after-sales/types/requests.types'

export function useFormattedQueryParams(filters: Filter) {
  const nonEmptyQueryParams = Object.entries(filters).reduce(
    (nonEmptyFilters, [filterName, value]) => {
      if (isEmpty(value)) {
        return nonEmptyFilters
      }
      if (Array.isArray(value)) {
        const formattedMultiselectValues = value.join(',')

        return {
          ...nonEmptyFilters,
          [filterName]: formattedMultiselectValues,
        }
      }

      return {
        ...nonEmptyFilters,
        [filterName]: value,
      }
    },
    {},
  )

  return nonEmptyQueryParams
}
